export function runWithObject(object, allTypes, shouldCache, callback) {
    const state = {
        root: { '': object },
        types: allTypes,
        cache: shouldCache ? new Set() : null,
    };
    return callback(state) || state.root[''];
}
